import { Controller } from 'stimulus'

export default class extends Controller {
  initialize() {
    const menu = this.element
    menu.onchange = () => {
      if (menu.options[menu.selectedIndex].value !== '') {
        location.href = menu.options[menu.selectedIndex].value
      }
    }
  }
}
